import React from 'react';
import { MultiSelect, Option } from '../../../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from './CollapsibleFilterBar';

// Wire-specific filter constants
const WIRE_STATUS_TYPES = ['Available', 'Consumed'] as const;

interface WireFilters {
  status: string[];
  lotNumber: string[];
  serialNumber: string[];
  manufacturer: string[];
  batchNumber: string[];
}

interface WireFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filters: WireFilters;
  onFilterChange: (key: keyof WireFilters) => (value: string[]) => void;
  uniqueLotNumbers: string[];
  uniqueSerialNumbers: string[];
  uniqueManufacturers: string[];
  uniqueBatchNumbers: string[];
  hasActiveFilters: boolean;
  filteredCount: number;
  onResetFilters: () => void;
}

export const WireFilters: React.FC<WireFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  onFilterChange,
  uniqueLotNumbers,
  uniqueSerialNumbers,
  uniqueManufacturers,
  uniqueBatchNumbers,
  hasActiveFilters,
  filteredCount,
  onResetFilters,
}) => {
  // Convert arrays to options for MultiSelect
  const statusOptions: Option[] = WIRE_STATUS_TYPES.map(status => ({
    value: status,
    label: status
  }));

  const lotNumberOptions: Option[] = uniqueLotNumbers.map(lotNumber => ({
    value: lotNumber,
    label: lotNumber
  }));

  const serialNumberOptions: Option[] = uniqueSerialNumbers.map(serialNumber => ({
    value: serialNumber,
    label: serialNumber
  }));

  const manufacturerOptions: Option[] = uniqueManufacturers.map(manufacturer => ({
    value: manufacturer,
    label: manufacturer
  }));

  const batchNumberOptions: Option[] = uniqueBatchNumbers.map(batchNumber => ({
    value: batchNumber,
    label: batchNumber
  }));

  const activeFilterCount =
    filters.status.length +
    filters.lotNumber.length +
    filters.serialNumber.length +
    filters.manufacturer.length +
    filters.batchNumber.length;

  return (
    <CollapsibleFilterBar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search materials by lot number, serial number, or details..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="materials"
      onResetFilters={onResetFilters}
    >
      <MultiSelect
        options={statusOptions}
        selected={filters.status}
        onChange={onFilterChange('status')}
        placeholder="Status"
        isSearchable={false}
      />
      <MultiSelect
        options={lotNumberOptions}
        selected={filters.lotNumber}
        onChange={onFilterChange('lotNumber')}
        placeholder="Lot Number"
      />
      <MultiSelect
        options={serialNumberOptions}
        selected={filters.serialNumber}
        onChange={onFilterChange('serialNumber')}
        placeholder="Serial Number"
      />
      <MultiSelect
        options={manufacturerOptions}
        selected={filters.manufacturer}
        onChange={onFilterChange('manufacturer')}
        placeholder="Manufacturer"
      />
      <MultiSelect
        options={batchNumberOptions}
        selected={filters.batchNumber}
        onChange={onFilterChange('batchNumber')}
        placeholder="Batch Number"
      />
    </CollapsibleFilterBar>
  );
}; 